import { map, has } from "lodash";
const uuid = require("uuid");

export default ({
  id,
  configurations,
  contentHeader,
  fileHeader,
  dataTypes,
  pous,
}) => ({
  projectId: id,
  projectProperties: {
    fileHeaderId: fileHeader.id,
    contentHeaderId: contentHeader.id,
    project: {
      projectName: contentHeader.name,
      projectVersion: contentHeader.version,
      productName: fileHeader.productName,
      productVersion: fileHeader.productVersion,
      productRelease: fileHeader.productRelease,
    },
    author: {
      companyName: fileHeader.companyName,
      companyUrl: fileHeader.companyUrl,
      authorName: contentHeader.author,
      organization: contentHeader.organization,
    },
    graphics: {
      pageSize: contentHeader.pageSize,
      fbd: contentHeader.fbd,
      ld: contentHeader.ld,
      sfc: contentHeader.sfc,
    },
    miscellaneous: {
      language: contentHeader.language,
      contentDescription: fileHeader.contentDescription,
    },
  },
  configuration: {
    id: configurations[0].id,
    globalVars: map(configurations[0].globalVars, parseVariable),
    resources: map(configurations[0].resources, (resource) => ({
      ...resource,
      globalVars: map(resource.globalVars, parseVariable),
      tasks: map(resource.tasks, (task) => ({
        ...task,
        pouInstances: map(task.pouInstances, (pouInstance) => ({
          ...pouInstance,
          tempId: uuid.v4(),
        })),
        tempId: uuid.v4(),
      })),
      pouInstances: map(resource.pouInstances, (pouInstance) => ({
        ...pouInstance,
        tempId: uuid.v4(),
      })),
      tempId: uuid.v4(),
    })),
  },
  dataTypes: map(dataTypes, (dataType) => ({
    ...dataType,
    tempId: uuid.v4(),
    derivationType: calcDerivationType(dataType),
    baseType:
      dataType.baseType.name === "struct"
        ? {
            ...dataType.baseType,
            elements: map(dataType.baseType.elements, parseVariable),
          }
        : dataType.baseType,
  })),
  pous: map(pous, (pou) => ({
    ...pou,
    body: pou.bodies[0],
    variables: map(pou.variables, parseVariable),
    tempId: uuid.v4(),
  })),
});

function calcDerivationType(dataType) {
  if (has(dataType, "baseType.minimum")) {
    return "Subrange";
  }

  if (has(dataType, "baseType.values")) {
    return "Enumerated";
  }

  if (has(dataType, "baseType.dimensions")) {
    return "Array";
  }

  if (has(dataType, "baseType.elements")) {
    return "Structure";
  }

  return "Directly";
}

function parseVariable(variable) {
  if (variable.type.name === "array") {
    return {
      tempId: uuid.v4(),
      ...variable,
      type: {
        ...variable.type,
        dimensions: map(variable.type.dimensions, (dimension) => ({
          ...dimension,
          tempId: uuid.v4(),
        })),
      },
    };
  }

  return {
    tempId: uuid.v4(),
    ...variable,
  };
}
